import { render, staticRenderFns } from "./CrossClose.vue?vue&type=template&id=019fb3dc&"
import script from "./CrossClose.vue?vue&type=script&lang=js&"
export * from "./CrossClose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports